<template>

<v-dialog v-model="dialog" width="600px">
  <v-card>
    <v-card-title>
    Key codes {{hspl.plan_code }} <v-spacer></v-spacer> <v-btn class="primary ma-2" @click="addPlsc(hspl.hspl_encrid)">Add Keycode</v-btn> 
    </v-card-title>
    <v-form ref="updPlsc" v-model="updPlscValid">
          


     <v-simple-table>
       <template v-slot:default>
       <thead>
         <tr>
         <td><b>From date</b></td>
         <td><b>Key code</b></td>
         </tr>
       </thead>
       <tbody>
       <tr  v-for="(plscRecord,i) in hspl.plsc" :key="i">
         <td>{{plscRecord.plsc_datum}}</td>
         <td>{{plscRecord.plsc_code}}</td>
         <td><v-btn text icon  @click="rmPlsc(plscRecord.plsc_encrid)"><v-icon small>mdi-trash-can-outline</v-icon></v-btn></td>
       </tr>    
       </tbody>
       </template>
     </v-simple-table>

     

    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
    <rmPlsc ref="rmPlsc"></rmPlsc>
    <addPlsc ref="addPlsc"></addPlsc>
  </v-card>
</v-dialog>

</template>

<script>
import rmPlsc from "@/views/huis/hspl/plsc/rmPlsc.vue";
import addPlsc from "@/views/huis/hspl/plsc/addPlsc.vue";
export default {
  components: {
       rmPlsc,
       addPlsc
   },   
  data() { 
    return {
      dialog: false,
      hspl_encrid: null,
      updPlscValid: false,
      hspl: {}
    }
  },
  methods: {
    open(hspl_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huis/hspl/plsc/getPlscOfHspl.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getPlscOfHspl"
          },
          getPlscOfHspl: {
            hspl_encrid: hspl_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hspl = res.data.getPlscOfHspl;
            this.huis_encrid = res.data.getPlscOfHspl.huis_encrid;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addPlsc(hspl_encrid) {
       this.$refs.addPlsc.open(hspl_encrid);
       this.dialog = false;
    },
    rmPlsc(plsc_encrid) {
       this.$refs.rmPlsc.open(plsc_encrid);
       this.dialog = false;
    }
  }
}
</script>

